import { useContext } from 'react';

import { PartnerIntakeContext } from '@/Contexts/PartnerIntakeContext';

import ExistingPartnerSelect from '../common/ExistingPartnerSelect';
import NewPartnerSection from '../common/IntakeNewPartnerSection';
import NewPartnerSectionHeader from '../common/IntakeNewPartnerSectionHeader';
import IntakePrimaryContact from '../common/IntakePrimaryContact';
import IntakeShippingContact from '../common/IntakeShippingContact';
import IntakeSubmitButton from '../common/IntakeSubmitButton';
import NewPartnerCheckbox from '../common/NewPartnerCheckbox';
import PartnerCategoryInput from '../common/PartnerCategoryInput';
import PartnerNameInput from '../common/PartnerNameInput';
import { IntakeResponse } from '@/models/IntakeResponse';

function TreeLineSignUp({ onSubmit }: { onSubmit: (intakeResponse: IntakeResponse) => void }) {
  const { isNewPartner, disabledNewPartnerCheckbox, selectedProgramInfo } =
    useContext(PartnerIntakeContext);

  return (
    selectedProgramInfo && (
      <>
        <IntakePrimaryContact />

        {!isNewPartner && <ExistingPartnerSelect />}

        {!disabledNewPartnerCheckbox && <NewPartnerCheckbox />}

        {isNewPartner && (
          <NewPartnerSection>
            <NewPartnerSectionHeader />

            {selectedProgramInfo?.displayCategory == 1 && <PartnerCategoryInput />}

            <PartnerNameInput />

            <IntakeShippingContact />
          </NewPartnerSection>
        )}
        <IntakeSubmitButton onSubmit={onSubmit} />
      </>
    )
  );
}

export default TreeLineSignUp;
